import { Select } from './Select';
import { TIMEZONE_OPTIONS } from '../../constants/datetime';

interface TimezoneSelectProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: () => void;
  error?: string;
  required?: boolean;
}

export function TimezoneSelect({ value, onChange, onBlur, error, required }: TimezoneSelectProps) {
  return (
    <Select
      label={required ? 'Timezone *' : 'Timezone'}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      options={TIMEZONE_OPTIONS}
      placeholder="Select timezone..."
      helpText="Required — used for scheduling, quiet hours, and guest-facing times"
      error={error}
    />
  );
}
